import React from 'react';
import PropTypes from 'prop-types';
import { usePopupState, bindToggle, bindPopover } from 'material-ui-popup-state/hooks';
import Popover from '@material-ui/core/Popover';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@/modules/common/components/TextField';

function getPopoverProp(id, position) {
    const props = {
        id: id,
        anchorOrigin: {},
        transformOrigin: {},
    };
    switch (position) {
        case 'right':
            props.anchorOrigin.vertical = 'center';
            props.anchorOrigin.horizontal = 'right';
            props.transformOrigin.vertical = 'center';
            props.transformOrigin.horizontal = 'left';
            break;
        case 'bottom': default:
            props.anchorOrigin.vertical = 'bottom';
            props.anchorOrigin.horizontal = 'center';
            props.transformOrigin.vertical = 'top';
            props.transformOrigin.horizontal = 'center';
    }
    return props;
}

const TextHelpField = (props) => {
    // noinspection JSCheckFunctionSignatures
    const popupState = usePopupState({variant: 'popover'});

    const properties = {...props};
    const popover = {...properties.popover};
    delete properties.popover;

    // noinspection JSValidateTypes
    return (
        <TextField {...properties} InputProps={{endAdornment:<>
                <InputAdornment position="end">
                    <IconButton size="small" edge="end" {...bindToggle(popupState)}>?</IconButton>
                </InputAdornment>
                <Popover className="popover-help" {...bindPopover(popupState)}
                         {...getPopoverProp(popover.id, popover.position)}
                >
                    {props.children}
                </Popover>
            </>}}
        />
    );
};

TextHelpField.propTypes = {
    popover: PropTypes.object,
};

export default TextHelpField;
